// material
import ModernTable from '../../components/ModernTable';
import { useTheme } from '@mui/material/styles';
import { Box, Typography, Chip, alpha } from '@mui/material';
import CategoryIcon from '@mui/icons-material/Category';
import DescriptionIcon from '@mui/icons-material/Description';

export default function CateTable(props) {
  const theme = useTheme();
  const { data, machinesName } = props;

  const columns = [
    {
      title: 'Name',
      field: 'name',
      render: (rowData) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CategoryIcon sx={{ fontSize: 16, color: theme.palette.text.secondary }} />
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            {rowData.name}
          </Typography>
        </Box>
      ),
    },
    {
      title: 'Category Page',
      field: 'detail',
      render: (rowData) => (
        <Chip
          icon={<DescriptionIcon sx={{ fontSize: 16 }} />}
          label={rowData.detail}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.primary.main, 0.12),
            color: theme.palette.primary.dark,
            border: `1.5px solid ${alpha(theme.palette.primary.main, 0.3)}`,
            '& .MuiChip-icon': {
              color: theme.palette.primary.dark,
            },
          }}
        />
      ),
    },
  ];

  return (
    <ModernTable
      title={'Categories: ' + machinesName}
      columns={columns}
      data={data}
      options={{
        actionsColumnIndex: -1,
        pageSize: 5,
        paging: true,
        search: false,
      }}
    />
  );
}
